import { Controller } from "@hotwired/stimulus";
import "clipboard/dist/clipboard.min.js";
import ClipboardJS from "clipboard";

export default class extends Controller {
  connect() {
    new ClipboardJS(this.element);
  }
}
